import { ExtractComponentProp } from '@approvalmax/types';
import { Box, Tabs } from '@approvalmax/ui/src/components';
import moment from 'moment';
import { memo, useMemo } from 'react';
import { AccountingDomainEntitiesBudgetCheckPeriod } from 'shared/data/webApp/v2';

import { BudgetAmountsInfo } from './components/BudgetAmountsInfo/BudgetAmountsInfo';
import { messages } from './QBooksBudgetImpactBreakdowns.messages';
import { QBooksBudgetImpactBreakdownsProps } from './QBooksBudgetImpactBreakdowns.types';

export const QBooksBudgetImpactBreakdowns = memo<QBooksBudgetImpactBreakdownsProps>((props) => {
    const { breakdowns, budgetAmounts, budgetPeriod, budgetCheckPeriod, budgetCurrency, requestFriendlyName } = props;

    const tabList = useMemo(() => {
        const breakdownTabs: ExtractComponentProp<typeof Tabs, 'items'> = breakdowns.map((breakdown) => {
            return {
                label: moment(breakdown.monthOfYear.asDateTime).format('MMM'),
                children: (
                    <BudgetAmountsInfo
                        budgetAmounts={breakdown.budgetAmounts}
                        budgetCurrency={budgetCurrency}
                        period={moment.utc(breakdown.monthOfYear.asDateTime).format('MMM YYYY')}
                        requestFriendlyName={requestFriendlyName}
                    />
                ),
            };
        });

        const tabsWithFullPeriod: ExtractComponentProp<typeof Tabs, 'items'> = [
            {
                label: messages.fullPeriod,
                children: (
                    <BudgetAmountsInfo
                        budgetAmounts={budgetAmounts}
                        budgetCurrency={budgetCurrency}
                        period={budgetPeriod}
                        requestFriendlyName={requestFriendlyName}
                    />
                ),
            },
            ...breakdownTabs,
        ];

        return budgetCheckPeriod === AccountingDomainEntitiesBudgetCheckPeriod.Monthly
            ? breakdownTabs
            : tabsWithFullPeriod;
    }, [breakdowns, budgetAmounts, budgetPeriod, budgetCheckPeriod, budgetCurrency, requestFriendlyName]);

    return (
        <Box bordered borderColor='midnight50' radius='small' spacing='8 0 0 0' overflowX='hidden'>
            <Tabs items={tabList} size='small' spacing='24 16 16 16' overflowX='auto' />
        </Box>
    );
});

QBooksBudgetImpactBreakdowns.displayName = 'QBooksBudgetImpactBreakdowns';
